const css = `@charset "UTF-8";
@import url("https://fonts.googleapis.com/css2?family=Reddit+Mono:wght@200..900&display=swap");
._provider_1f6s0_3[data-theme=light] {
  --bg-color: #fff;
  --loading-color: #252525;
  --text-color: #252525;
  --secondary-text-color: #666;
  --border-color: #eee;
  --secondary-border-color: #252525;
  --button-hover-bg-color: #000;
  --button-hover-text-color: #eee;
  --link-color: #00469b;
  --code-background-color: #f5f5f5;
  --code-text-color: #252525;
  --drawer-background-color: rgba(255, 255, 255, 0.45);
  --modal-background-color: rgba(255, 255, 255, 0.95);
  --success-color: #50c878;
  --failure-color: #880808;
  --disabled-color: #f5f5f5;
  --noise-brightness: brightness(180%);
  --noise-background-color: #00469b;
  --box-shadow: 0 0 16px rgba(0, 0, 0, 0.05);
}

._provider_1f6s0_3[data-theme=dark] {
  --bg-color: #252525;
  --loading-color: #f3f3f3;
  --text-color: #fff;
  --secondary-text-color: #ccc;
  --border-color: #444;
  --secondary-border-color: #fff;
  --button-hover-bg-color: #444;
  --button-hover-text-color: #fff;
  --link-color: #3773e1;
  --code-background-color: #444;
  --code-text-color: #fff;
  --drawer-background-color: rgba(37, 37, 37, 0.45);
  --modal-background-color: rgba(37, 37, 37, 0.95);
  --success-color: #0bda51;
  --failure-color: #770737;
  --disabled-color: #212121;
  --noise-brightness: brightness(40%);
  --noise-background-color: #3773e1;
  --box-shadow: 0 0 16px rgba(255, 255, 255, 0.05);
}
._provider_1f6s0_3[data-theme=dark] ::global(body) {
  background-color: var(--bg-color);
}

._provider_1f6s0_3 {
  --font-family: "Helvetica Neue", Helvetica, HB TC, HB JP, HB KR, Arial,
    "Segoe UI", “microsoft jhenghei”, “microsoft mhei”, -apple-system,
    BlinkMacSystemFont, sans-serif;
  background-color: var(--bg-color);
  color: var(--text-color);
  border-color: var(--border-color);
  font-family: var(--font-family);
  font-size: 18px;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  --noise: url("data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycKICB4bWxuczp4bGluaz0naHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluaycKICB3aWR0aD0nMTI4MCcgaGVpZ2h0PScxMjgwJz4KCiAgICA8ZmlsdGVyIGlkPSduJyB4PScwJyB5PScwJz4KICAgICAgICAgICAgPGZlVHVyYnVsZW5jZQogICAgICAgICAgICAgIHR5cGU9J2ZyYWN0YWxOb2lzZScKICAgICAgICAgICAgICBiYXNlRnJlcXVlbmN5PScwLjk1JwogICAgICAgICAgICAgIHN0aXRjaFRpbGVzPSdzdGl0Y2gnLz4KICAgIDwvZmlsdGVyPgoKICAgIDwhLS0gPHJlY3Qgd2lkdGg9JzEyODAnIGhlaWdodD0nMTI4MCcgZmlsbD0nI2ZmZicvPiAtLT4KICAgIDxyZWN0IHdpZHRoPScxMjgwJyBoZWlnaHQ9JzEyODAnIGZpbHRlcj0idXJsKCNuKSIgb3BhY2l0eT0nMC44Jy8+Cjwvc3ZnPg==");
  --font-description: var(--font-family);
  --font-date-and-tags: "Reddit Mono", "Helvetica Neue", Helvetica, HB TC, HB JP,
    HB KR, Arial, "Segoe UI", “microsoft jhenghei”, “microsoft mhei”,
    -apple-system, BlinkMacSystemFont, sans-serif;
}
@media (max-width: 767px) {
  ._provider_1f6s0_3 {
    font-size: 16px;
  }
}

body {
  font-size: 18px;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  line-height: normal;
}

h1 {
  font-size: 2.22em;
  font-weight: 700;
}

h2 {
  font-size: 1.88em;
  font-weight: 700;
}

h3 {
  font-size: 1.66em;
  font-weight: 700;
}

h4 {
  font-size: 1.2em;
  font-weight: 500;
}

h5 {
  font-size: 1.1em;
  font-weight: 500;
}

h6 {
  font-size: 1em;
  font-weight: 500;
  line-height: 1.25em;
  text-transform: uppercase;
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a {
  color: inherit;
  text-decoration: none;
}

img,
svg {
  display: block;
}

a {
  color: var(--link-color);
  text-decoration: none;
}

p {
  font-size: 1em;
  line-height: 1.5em;
  text-align: justify;
}

p a {
  font-weight: 500;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--border-color);
  height: 0;
  width: 100%;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "provider": "_provider_1f6s0_3"
};